'use client';

import { motion } from 'framer-motion';
import type { MockBoard } from '../data/mock-boards';
import { BoardMetadataSnapshot } from './board-metadata-snapshot';
import { cn } from '@/lib/utils';

interface BoardTooltipProps {
  board: MockBoard;
  className?: string;
}

/** Hover preview — same content as the pinned metadata card (no extra stats). */
export function BoardTooltip({ board, className }: BoardTooltipProps) {
  return (
    <motion.div
      initial={{ opacity: 0, x: -6, scale: 0.98 }}
      animate={{ opacity: 1, x: 0, scale: 1 }}
      transition={{ duration: 0.16, ease: [0.2, 0.8, 0.2, 1] }}
      className={cn('pointer-events-auto', className)}
    >
      <BoardMetadataSnapshot board={board} className="shadow-[0_25px_60px_-20px_rgba(0,0,0,0.9)]" />
    </motion.div>
  );
}
